import { render, staticRenderFns } from "./DashAdminMobile.vue?vue&type=template&id=0b490b0f&scoped=true&"
import script from "./DashAdminMobile.vue?vue&type=script&lang=js&"
export * from "./DashAdminMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b490b0f",
  null
  
)

export default component.exports